module.exports = __webpack_public_path__ + "img/Dantam Hair 14.cc4559ec.jpg";